import { useAlert } from '@/src/components/ui/elements/dialogs/useAlert'
import { graphql } from '@api/mesa'
import { useMutation } from '@apollo/client'
import { useLogError } from '@/src/common/hooks/useLogError'
import { GET_LINKED_EXTERNAL_ACCOUNTS } from '@/src/common/gql/queries/card'
import * as CardActivity from '@/src/experiences/card-activity'

export function useCloseLinkedExternalBankAccount() {
  const Alert = useAlert(useCloseLinkedExternalBankAccount.name)
  const logError = useLogError()

  return useMutation(
    graphql(`
      mutation closeLinkedExternalBankAccount(
        $highnoteExternalAccountId: String
        $plaidAccountId: String
      ) {
        closeLinkedExternalBankAccountV2(
          highnoteExternalAccountId: $highnoteExternalAccountId
          plaidAccountId: $plaidAccountId
        ) {
          __typename
          ... on MesaUserError {
            message
          }
        }
      }
    `),
    {
      onError(error) {
        logError(error)
        Alert.alert(
          'Sorry!',
          "The External Bank Account couldn't be deleted. Please try again later.",
        )
      },
      onCompleted({ closeLinkedExternalBankAccountV2: data }) {
        if (data.__typename === 'MesaUserError') {
          Alert.alert("The External Bank Account couldn't be deleted", data.message)
        }
      },
      refetchQueries: [
        GET_LINKED_EXTERNAL_ACCOUNTS,
        CardActivity.Components.Highnote.ScheduledTransfers.GET_INCOMING_SCHEDULED_TRANSFERS,
      ],
    },
  )
}
